import React from "react";
import {Col, Container, Row} from "reactstrap";

const Header = () => (
    <Container fluid className={"test-header font-alter-1"}>
        <Row>
            <Col md={{size: 3}}><h1>Психолог Муздракова</h1></Col>
            <Col md={{size: 6}} className={"text-center"}><h1>Тест за депресия на д-р Дейвид Бърнс</h1></Col>
        </Row>
    </Container>
);

export default Header